import React, { useState, lazy, Suspense } from 'react';
import { Etiketleme, KanunMaddeleri } from './duzenleme/Etiketleme';
import { birlestirVeNormalizeKanunMaddeleri } from '../../utils/kanunMaddeNormalizasyon';
import AIEnhancer from './duzenleme/AIEnhancer';
import { KategoriSecici, Kategori } from './Kategorilendirme';
import { toast } from 'react-toastify';
import 'react-quill/dist/quill.snow.css';

const ReactQuill = lazy(() => import('react-quill'));

const YeniSablonEkle = ({
  kategoriler,
  tumEtiketler,
  tumKanunMaddeleri,
  onKaydet,
  onIptal,
  onSablonEklendi
}) => {
  const [sablon, setSablon] = useState({
    baslik: '',
    ozet: '',
    icerik: '',
    etiketler: [],
    kanun_maddeleri: [],
    kategoriler: []
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSablon(prev => ({ ...prev, [name]: value }));
  };

  const handleIcerikChange = (icerik) => {
    setSablon(prev => ({ ...prev, icerik }));
  };

  const handleSelectChange = (field, selectedOptions) => {
    if (field === 'kategoriler') {
      const updatedKategoriler = selectedOptions
        .filter(option => option instanceof Kategori && option.id && option.isim)
        .map(option => new Kategori(option.id, option.isim));
      setSablon(prev => ({ ...prev, [field]: updatedKategoriler }));
    } else {
      setSablon(prev => ({
        ...prev,
        [field]: Array.isArray(selectedOptions) ? selectedOptions.filter(Boolean) : [selectedOptions].filter(Boolean)
      }));
    }
  };

  const handleAIEnhance = ({ ozet, baslik, etiketler, kanunMaddeleri }) => {
    setSablon(prev => ({
      ...prev,
      ozet,
      baslik,
      etiketler: [...new Set([...prev.etiketler, ...etiketler])],
      kanun_maddeleri: birlestirVeNormalizeKanunMaddeleri(prev.kanun_maddeleri, kanunMaddeleri)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!sablon.kategoriler || sablon.kategoriler.length === 0) {
        throw new Error('En az bir kategori seçilmelidir.');
      }

      const sablonToSave = {
        ...sablon,
        kategoriler: sablon.kategoriler
          .filter(kategori => kategori instanceof Kategori && typeof kategori.id === 'number' && kategori.isim)
          .map(kategori => ({
            id: kategori.id,
            isim: kategori.isim
          }))
      };

      const yeniSablon = await onKaydet(sablonToSave);
      if (yeniSablon) {
        onSablonEklendi(yeniSablon);
        toast.success('Yeni şablon başarıyla eklendi.');
        onIptal();
      } else {
        throw new Error('Şablon eklenemedi');
      }
    } catch (error) {
      console.error('Şablon eklenirken hata:', error);
      toast.error(`Şablon eklenirken bir hata oluştu: ${error.message}`);
    }
  };

  return (
    <div className="app-card flex flex-col">
      <div className="app-header">
        <h2 className="app-header-title relative z-10">Yeni Şablon Ekle</h2>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col space-y-6 p-6">
        <div>
          <label htmlFor="baslik" className="app-label">Başlık</label>
          <input
            type="text"
            id="baslik"
            name="baslik"
            value={sablon.baslik}
            onChange={handleChange}
            className="app-input"
          />
        </div>

        <div>
          <label htmlFor="ozet" className="app-label">Özet</label>
          <textarea
            id="ozet"
            name="ozet"
            value={sablon.ozet}
            onChange={handleChange}
            rows="3"
            className="app-input"
          />
        </div>

        <div className="relative z-10 space-y-2">
          <label htmlFor="icerik" className="app-label">İçerik</label>
          <div className="rounded-xl border border-slate-200 bg-slate-50/70 p-3">
            <div className="h-[calc(100vh-460px)] min-h-[320px] overflow-hidden">
              <Suspense fallback={<div className="p-4 text-sm text-slate-400">Yükleniyor...</div>}>
                <ReactQuill
                  value={sablon.icerik}
                  onChange={handleIcerikChange}
                  className="h-full pb-12"
                  theme="snow"
                  modules={{
                    toolbar: [
                      [{ 'header': [1, 2, 3, false] }],
                      ['bold', 'italic', 'underline'],
                      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                      ['link', 'image'],
                      ['clean']
                    ],
                  }}
                  ref={(el) => {
                    if (el) {
                      el.getEditor().root.setAttribute('data-gramm', 'false');
                    }
                  }}
                />
              </Suspense>
            </div>
          </div>
        </div>

        <div className="relative z-50 grid grid-cols-1 gap-6 md:grid-cols-2">
          <div className="relative z-50">
            <Etiketleme
              etiketler={sablon.etiketler}
              onChange={(yeniEtiketler) => handleSelectChange('etiketler', yeniEtiketler)}
              kayitliEtiketler={tumEtiketler}
            />
          </div>
          <div className="relative z-50">
            <KanunMaddeleri
              kanunMaddeleri={sablon.kanun_maddeleri}
              onChange={(yeniKanunMaddeleri) => handleSelectChange('kanun_maddeleri', yeniKanunMaddeleri)}
              kayitliKanunMaddeleri={tumKanunMaddeleri}
            />
          </div>
        </div>

        <div className="relative z-40">
          <label className="app-label">Kategoriler</label>
          <KategoriSecici
            kategoriler={kategoriler}
            secilenKategoriler={sablon.kategoriler}
            onChange={(selectedOptions) => handleSelectChange('kategoriler', selectedOptions)}
          />
        </div>
      </form>

      <div className="relative z-30 flex flex-wrap items-center justify-between gap-3 border-t border-slate-200 bg-slate-50 p-6">
        <AIEnhancer
          icerik={sablon.icerik}
          onEnhance={handleAIEnhance}
          tumEtiketler={tumEtiketler}
          tumKanunMaddeleri={tumKanunMaddeleri}
        />
        <div className="flex items-center gap-2">
          <button type="button" onClick={onIptal} className="btn-secondary">
            İptal
          </button>
          <button type="button" onClick={handleSubmit} className="btn-primary">
            Kaydet
          </button>
        </div>
      </div>
    </div>
  );
};

export default YeniSablonEkle;
